﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class OrganizationClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    get(organizationAppId) {
        return this.client.apiOrganizationsByIdGet(organizationAppId);
    }
    getEditableOrganizations() {
        return this.client.apiOrganizationsEditableGet();
    }
}
exports.OrganizationClient = OrganizationClient;
//# sourceMappingURL=OrganizationClient.js.map